/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".list-empty-state[_ngcontent-%COMP%]{padding-top:40px;padding-bottom:30px}@media (min-width:0) and (max-width:500px){.list-empty-state[_ngcontent-%COMP%]{text-align:center;padding-top:40px}}.list-empty-state__copy[_ngcontent-%COMP%]{width:74.57627119%;float:left;margin-right:1.69491525%}@media (min-width:0) and (max-width:767px){.list-empty-state__copy[_ngcontent-%COMP%]{width:100%;float:left;margin-left:0;margin-right:0}}"];
export { styles as styles };
